import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './redux/reducers';

let initialState = {};
const middleware = [thunk];

// Fix robusto para Redux DevTools con fallbacks
const composeEnhancers = (() => {
	// Verificar si estamos en desarrollo
	const isDevelopment = process.env.NODE_ENV === 'development';
	
	// Verificar si estamos en el navegador
	const isClient = typeof window !== 'undefined';
	
	// Intentar usar Redux DevTools si está disponible
	if (isDevelopment && isClient) {
		try {
			// Verificar si Redux DevTools está disponible
			const devTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
			
			if (devTools && typeof devTools === 'function') {
				return devTools({
					// Configuración opcional para DevTools
					trace: true,
					traceLimit: 25
				});
			}
		} catch (error) {
			console.warn('Redux DevTools not available:', error);
		}
	}
	
	// Fallback seguro: usar compose nativo
	return compose;
})();

// Crear store con manejo de errores
let store;

try {
	store = createStore(
		rootReducer,
		initialState,
		composeEnhancers(applyMiddleware(...middleware))
	);
	
	console.log('✅ Redux store creado exitosamente');
	
} catch (error) {
	console.error('❌ Error creando Redux store:', error);
	
	// Crear store básico como fallback
	store = createStore(
		rootReducer,
		initialState,
		applyMiddleware(...middleware)
	);
	
	console.warn('⚠️ Store creado sin DevTools como fallback');
}

// Verificar que el store funcione correctamente
if (store && typeof store.getState === 'function') {
	console.log('✅ Store verificado y funcionando');
} else {
	console.error('❌ Store no funciona correctamente');
}

export default store;
